import { handleActions } from 'redux-actions';
import { callFlowsActions } from '../actions/callFlowsActions';
export const { callFlowsFetchAll, callFlowsFetchAllSucceeded, callFlowsFetchAllFailed, callFlowsDelete, callFlowsDeleteSucceeded, callFlowsDeleteFailed, telephonyGetQueryNumbersPage, telephonyGetQueryNumbersPageSucceeded, telephonyGetQueryNumbersPageFailed, } = callFlowsActions;
const initialState = {
    flows: [],
    meta: {
        asyncStatus: 'succeeded',
        callAsyncStatus: 'succeeded',
    },
    nextPage: null,
    numbers: [],
    previousPage: null,
};
// Reducer
const callFlows = handleActions({
    [callFlowsFetchAll.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { callAsyncStatus: 'loading' }) });
    },
    [callFlowsFetchAllSucceeded.toString()]: (state, action) => {
        var _a;
        const flows = ((_a = action.payload.data) === null || _a === void 0 ? void 0 : _a.conversation_flows) &&
            Array.isArray(action.payload.data.conversation_flows)
            ? action.payload.data.conversation_flows
            : [];
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { callAsyncStatus: 'succeeded' }), flows: flows });
    },
    [callFlowsFetchAllFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { callAsyncStatus: 'failed' }) });
    },
    [callFlowsDelete.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [callFlowsDeleteSucceeded.toString()]: (state, action) => {
        const { id } = action.payload.request;
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), flows: state.flows.filter((flow) => flow.id !== id) });
    },
    [callFlowsDeleteFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    [telephonyGetQueryNumbersPage.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [telephonyGetQueryNumbersPageSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), numbers: action.payload.data &&
                Array.isArray(action.payload.data.numbers) === true
                ? action.payload.data.numbers
                : [], nextPage: action.payload.meta ? action.payload.meta.next_page : null, previousPage: action.payload.meta
                ? action.payload.meta.prev_page
                : null });
    },
    [telephonyGetQueryNumbersPageFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    ['FLOW_DELETE_LOCAL']: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    ['FLOW_DELETE_LOCAL_SUCCEEDED']: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), flows: state.flows.filter((flow) => flow.id !== 'local') });
    },
    ['FLOW_DELETE_LOCAL_FAILED']: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    ['TELEPHONY_UPDATE_NUMBER_SUCCEEDED']: (state, action) => {
        let numbers = [...state.numbers];
        const updatedNumber = Object.assign({}, action.payload.data);
        const name = updatedNumber.name;
        const number = updatedNumber.e164_format;
        const record_outbound_calls = updatedNumber.record_outbound_calls;
        const foundNumber = numbers.find(({ e164_format }) => e164_format === number);
        if (foundNumber) {
            foundNumber.name = name; // update to new name.
            foundNumber.record_outbound_calls = record_outbound_calls;
            numbers = numbers.map((n) => n.e164_format === number ? foundNumber : n);
        }
        return Object.assign(Object.assign({}, state), { numbers });
    },
    ['TELEPHONY_BUY_GROUP_NUMBER_DELIVERED']: (state, action) => {
        const number = Object.assign({}, action.payload.data);
        const numberIndex = state.numbers.findIndex((n) => n.e164_format === number.e164_format);
        if (numberIndex && numberIndex > -1) {
            return Object.assign(Object.assign({}, state), { numbers: [
                    ...state.numbers.slice(0, numberIndex),
                    Object.assign({}, state.numbers[numberIndex], number),
                    ...state.numbers.slice(numberIndex + 1),
                ] });
        }
        return Object.assign(Object.assign({}, state), { numbers: [...state.numbers, number] });
    },
    ['TELEPHONY_RELEASE_NUMBER_SUCCEEDED']: (state, action) => {
        const deletedNumber = Object.assign({}, action.number);
        return Object.assign(Object.assign({}, state), { numbers: state.numbers.filter((n) => n.e164_format !== deletedNumber.e164_format) });
    },
    ['TELEPHONY_BUY_NUMBER']: (state, action) => {
        var _a;
        // We need this check if the number we buynot is known (not already in our pool).
        if ((_a = action.payload.number) === null || _a === void 0 ? void 0 : _a.e164_format) {
            const e164_format = action.payload.number.e164_format;
            const name = action.payload.name;
            const numberObj = {
                carrier: null,
                default: false,
                e164_format,
                incoming_functionality: false,
                incoming_verified: false,
                is_verified: false,
                name,
                number_type: null,
                outgoing_functionality: false,
                porting_date: null,
                record_outbound_calls: false,
                region: undefined,
            };
            return Object.assign(Object.assign({}, state), { numbers: [...state.numbers, numberObj] });
        }
        return state;
    },
    ['TELEPHONY_BUY_NUMBER_SUCCEEDED']: (state, action) => {
        const number = Object.assign({}, action.payload.data);
        const numberIndex = state.numbers.findIndex((n) => n.e164_format === number.e164_format);
        if (numberIndex && numberIndex > -1) {
            return Object.assign(Object.assign({}, state), { numbers: [
                    ...state.numbers.slice(0, numberIndex),
                    Object.assign({}, state.numbers[numberIndex], number),
                    ...state.numbers.slice(numberIndex + 1),
                ] });
        }
        return Object.assign(Object.assign({}, state), { numbers: [...state.numbers, number] });
    },
    ['TELEPHONY_BUY_NUMBER_FAILED']: (state, action) => {
        var _a, _b;
        const optimisticNumbersArray = state.numbers.slice();
        const numbers = ((_a = action.requestPayload) === null || _a === void 0 ? void 0 : _a.number)
            ? optimisticNumbersArray.filter((number) => number.e164_format !== action.requestPayload.number.e164_format)
            : [];
        if ((_b = action.requestPayload) === null || _b === void 0 ? void 0 : _b.number) {
            return Object.assign(Object.assign({}, state), { numbers });
        }
        return state;
    },
    ['FLOW_ADD_AFTER_BUY_NUMBER_SUCCEEDED']: (state, action) => {
        const addedFlow = Object.assign({}, action.flow);
        return Object.assign(Object.assign({}, state), { flows: [...state.flows, addedFlow] });
    },
}, initialState);
export default callFlows;
